import clsx from 'clsx';
import React from 'react';
import Lottie, { LottieComponentProps } from 'lottie-react';
import NCRLogo from 'src/common/media/ncr-logo-eps.svg';
import { styles } from './startup-animation-styles';

const StartupAnimation: React.FC<StartupAnimationProps> = ({
  lottieProps,
  hideAnimation,
}: StartupAnimationProps): JSX.Element => {
  const classes = styles();

  return (
    <div className={`fullHeight fullWidth`}>
      <img
        src={NCRLogo}
        className={clsx(classes.logo, !hideAnimation && classes.animation)}
        alt='ncr-logo'
      />
      <Lottie
        {...lottieProps}
        style={{
          height: '100%',
          width: '100%',
        }}
      />
    </div>
  );
};

export interface StartupAnimationProps {
  lottieProps: LottieComponentProps;
  eventListeners?: EventListener[];
  hideAnimation?: boolean;
}

export default StartupAnimation;
